import { createDynamicThunk } from ".";

export const getDashboardDetailsThunk = createDynamicThunk({
  typePrefix: "dashboardDetails/getDashboardDetailsThunk",
  endpoint: "/dashboardDetails",
  method: "POST",
  useHandleSearch: false,
});

export const getLimitedNotificationListThunk = createDynamicThunk({
  typePrefix: "notifications/getLimitedNotificationListThunk",
  endpoint: "/notifications/findAll",
  method: "POST",
});
